module.exports = __webpack_public_path__ + "img/sjgx6.42c40e01.png";